/**
 * Region Constants
 * Domain-specific constants and configuration
 */

// ===========================================
// Status Configuration
// ===========================================

export const REGION_STATUS_CONFIG = {
  active: {
    label: 'Active',
    color: 'emerald',
    bgClass: 'bg-emerald-100 dark:bg-emerald-900/30',
    textClass: 'text-emerald-600 dark:text-emerald-400',
  },
  inactive: {
    label: 'Inactive',
    color: 'slate',
    bgClass: 'bg-slate-100 dark:bg-slate-800',
    textClass: 'text-slate-600 dark:text-slate-400',
  },
} as const

// ===========================================
// Default Values
// ===========================================

export const DEFAULT_REGION_FILTER = {
  isActive: 'all' as const,
  search: '',
}

export const DEFAULT_REGION_STATS = {
  total: 0,
  active: 0,
  inactive: 0,
  byCountry: {} as Record<string, number>,
}

// ===========================================
// Pagination
// ===========================================

export const DEFAULT_PAGE_SIZE = 20
export const REGION_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

// ===========================================
// Form Field Names
// ===========================================

export const REGION_FIELDS = {
  CODE: 'code',
  NAME: 'name',
  DESCRIPTION: 'description',
  IS_ACTIVE: 'isActive',
  COUNTRY_ID: 'countryId',
  FACTORY_IDS: 'factoryIds',
} as const

// ===========================================
// Translation Keys
// ===========================================

export const T_KEYS = {
  REGIONS: {
    TITLE: 'regions.title',
    SUBTITLE: 'regions.subtitle',
    ADD_REGION: 'regions.addRegion',
    EDIT_REGION: 'regions.editRegion',
    DELETE_REGION: 'regions.deleteRegion',
    FORM: {
      CODE: 'regions.form.code',
      CODE_PLACEHOLDER: 'regions.form.codePlaceholder',
      NAME: 'regions.form.name',
      NAME_PLACEHOLDER: 'regions.form.namePlaceholder',
      DESCRIPTION: 'regions.form.description',
      DESCRIPTION_PLACEHOLDER: 'regions.form.descriptionPlaceholder',
      COUNTRY: 'regions.form.country',
      SELECT_COUNTRY: 'regions.form.selectCountry',
      FACTORIES: 'regions.form.factories',
      SELECT_FACTORIES: 'regions.form.selectFactories',
      IS_ACTIVE: 'regions.form.isActive',
    },
    VALIDATION: {
      CODE_REQUIRED: 'regions.validation.codeRequired',
      NAME_REQUIRED: 'regions.validation.nameRequired',
    },
    STATS: {
      TOTAL: 'regions.stats.total',
      ACTIVE: 'regions.stats.active',
      INACTIVE: 'regions.stats.inactive',
    },
    DETAIL: {
      FACTORIES: 'regions.detail.factories',
      CITIES: 'regions.detail.cities',
      NO_FACTORIES: 'regions.detail.noFactories',
      NO_CITIES: 'regions.detail.noCities',
    },
  },
  COMMON: {
    SAVE: 'common.save',
    CANCEL: 'common.cancel',
    DELETE: 'common.delete',
    LOADING: 'common.loading',
    SEARCH: 'common.search',
    FILTER: 'common.filter',
    ALL: 'common.all',
    ACTIVE: 'common.active',
    INACTIVE: 'common.inactive',
  },
} as const
